import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const City = () => {
  const { cityId } = useParams();
  const [cityData, setCityData] = useState(null);
  useEffect(() => {
    fetch(`https://dayoffice24.it/api/property/city-id/${cityId}`)
      .then((response) => response.json())
      .then((data) => {
        console.log('API Response:', data);
        if (data.success && data.data && data.data.length > 0) {
          setCityData(data.data);
        } else {
          setCityData(null);
        }
      })
      .catch((error) => {
        console.error('Error fetching city data:', error);
        setCityData(null);
      });
  }, [cityId]);


  console.log('City Data:', cityData);

  if (!cityData) {
    return <div>Loading city data...</div>;
  }

  // Check if cityData.city is not undefined before accessing city name
  const cityName = cityData[0]?.city?.city_name || 'City Not Found';

  return (
    <div className="main_wrap">
      <Header />

      <div className="content-wrapper">
        <div className="breadcrumb-wrap bg-f br-2">
          <div className="container">
            <div className="breadcrumb-title text-center">
              <h2>{cityName}</h2>
              <ul className="breadcrumb-menu list-style">
                <li><a href="/">Home</a></li>
                <li>{cityName}</li>
              </ul>
            </div>
          </div>
        </div>

        <section className="listing-wrap ptb-100">
          <div className="container">
            <div className="row">
              {cityData.map((property) => (
                <div key={property._id} className="col-xl-4 col-lg-6 col-md-6">
                  <div className="property-card style4">
                    <div className="property-img">
                      <Link to={`/PropertyView/${property._id}`}><img src={property.thumb_image} alt="Image" /></Link>
                       <span className="property-status">{property.property_type}</span>
                    </div>
                    <div className="property-info">
                      <h3><Link to={`/PropertyView/${property._id}`}>{property.property_name}</Link></h3>
                      <p>{property.availableDates.view_date}</p>
                      <p><i className="flaticon-location"></i>{property.address}</p>
                      <ul className="property-metainfo list-style"> 
                        <li><i className="flaticon-user-avatar"></i>{property.no_of_guest}</li>
                        <li><i className="flaticon-bath-tub"></i>{property.bathrooms}</li>
                        <li><i className="flaticon-square"></i>{property.property_size} sqft</li>
                      </ul>
                      <p className="property-price">€{property.price}/<span>{property.price_charge_type}</span></p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default City;
